(() => {
  if (window.__mrAvailablePurchasePicker) {
    window.__mrAvailablePurchasePicker.scan();
    return;
  }
  const sectionSelector = '[id^="shopify-section-template--"][id$="__main_product"]';
  const instances = new WeakMap();
  let observer;
  let frame = 0;

  function readConfig(node) {
    try {
      const data = JSON.parse(node.textContent);
      if (!/^\d+$/.test(data.productId) || data.productId === '15382636200240' ||
          !Array.isArray(data.allowedIds) || !Array.isArray(data.variants) ||
          !Array.isArray(data.optionNames) || data.optionNames.length !== 2 ||
          data.optionNames[0] !== 'Size' || data.optionNames[1] !== 'Finish') return null;
      const allowed = new Set(data.allowedIds.map(String));
      const intendedVariants = data.variants.filter(variant => allowed.has(String(variant.id)) &&
        typeof variant.available === 'boolean' && /^\d+$/.test(variant.id) &&
        Array.isArray(variant.options) && variant.options.length === 2 &&
        variant.options.every(value => typeof value === 'string' && value.length > 0));
      if (new Set(intendedVariants.map(variant => String(variant.id))).size !== intendedVariants.length ||
          new Set(intendedVariants.map(variant => JSON.stringify(variant.options))).size !== intendedVariants.length) return null;
      const variants = intendedVariants.filter(variant => variant.available === true);
      return { ...data, variants, intendedVariants };
    } catch {
      return null;
    }
  }

  const checkoutCountries = new Set(['AU', 'NZ', 'SG', 'HK', 'JP', 'MY', 'AE']);
  function enquiry(data) {
    const clean = (value, limit) => typeof value === 'string' && value.length > 0 &&
      value.length <= limit && !/[\u0000-\u001f\u007f-\u009f<>]/.test(value) ? value.trim() : '';
    const title = clean(data.productTitle, 160);
    const country = clean(data.countryName, 80);
    if (!title || !country || !/^[A-Z]{2}$/.test(data.countryCode)) return null;
    const destination = !checkoutCountries.has(data.countryCode);
    const requested = new URL(location.href).searchParams.getAll('variant');
    const preference = requested.length === 1 && requested[0] === String(data.selectedId)
      ? data.intendedVariants.find(variant => String(variant.id) === requested[0]) : null;
    if (!destination && data.variants.length && preference?.available !== false) return null;
    const url = new URL('/pages/contact', location.origin);
    url.searchParams.set('request', destination ? 'delivery-quote' : 'artwork-enquiry');
    url.searchParams.set('artwork', title);
    url.searchParams.set('country', country);
    if (preference) {
      const size = clean(preference.options[0], 120);
      const finish = clean(preference.options[1], 120);
      if (size && finish) {
        url.searchParams.set('size', size);
        url.searchParams.set('finish', finish);
      }
    }
    url.hash = 'ContactForm';
    if (url.href.length > 1800) return null;
    return { destination, title, country, href: url.pathname + url.search + url.hash };
  }

  function findMain(productId) {
    const matches = [...document.querySelectorAll(sectionSelector)].filter(section =>
      section.querySelector('xo-product[xo-product-information]')
        ?.getAttribute('xo-product-id') === productId);
    return matches.length === 1 ? matches[0] : null;
  }

  function build(data, main) {
    const existing = instances.get(main);
    if (existing?.isConnected) return;
    const nativePicker = [...main.querySelectorAll('xo-product-variants')].find(picker =>
      picker.closest('xo-product')?.getAttribute('xo-product-id') === data.productId);
    if (!nativePicker) return;
    const root = document.createElement('div');
    root.setAttribute('data-mr-available-picker', data.productId);
    const status = document.createElement('p');
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('aria-atomic', 'true');
    status.setAttribute('data-mr-selection-status', '');
    root.append(status);
    const contact = enquiry(data);
    if (contact) {
      status.textContent = contact.destination
        ? 'Delivery to ' + contact.country + ' is by quote.'
        : 'Please enquire about this artwork. We’ll confirm the options before you order.';
      const button = main.querySelector('.xo-buy-buttons__add-to-cart-detail xo-cart-add button') ||
        main.querySelector('xo-product[xo-product-information] xo-cart-add button');
      const link = document.createElement('a');
      link.className = (button?.className || 'xo-button') + ' mr-available-enquiry-link';
      link.href = contact.href;
      link.textContent = contact.destination ? 'Request a delivery quote' : 'Enquire about this artwork';
      link.setAttribute('aria-label', link.textContent + ': ' + contact.title + ', ' + contact.country);
      root.append(link);
      if (!contact.destination && data.variants.length) {
        try {
          const canonical = new URL(document.querySelector('link[rel="canonical"]')?.getAttribute('href'), location.href);
          const currentHandle = new URL(location.href).pathname.match(/\/products\/([a-z0-9][a-z0-9-]*)\/?$/)?.[1];
          if (canonical.origin === location.origin && currentHandle &&
              canonical.pathname === '/products/' + currentHandle) {
            const choices = document.createElement('a');
            choices.setAttribute('data-mr-available-choices', '');
            choices.href = canonical.pathname;
            choices.textContent = 'See available sizes and finishes';
            choices.style.cssText = 'display:block;margin-top:12px;text-decoration:underline;text-underline-offset:3px';
            root.append(choices);
          }
        } catch {}
      }
      main.setAttribute('data-mr-purchase-enquiry', contact.destination ? 'destination' : 'artwork');
      nativePicker.after(root);
      main.setAttribute('data-mr-available-picker-ready', data.productId);
      instances.set(main, root);
      return;
    }
    if (!data.variants.length) {
      status.textContent = 'Please enquire about this artwork using the Contact page.';
      const link = document.createElement('a');
      link.href = '/pages/contact#ContactForm';
      link.textContent = 'Enquire about this artwork';
      root.append(link);
      main.setAttribute('data-mr-purchase-enquiry', 'artwork');
      nativePicker.after(root);
      main.setAttribute('data-mr-available-picker-ready', data.productId);
      instances.set(main, root);
      return;
    }
    const storageKey = 'mr-variant-notice-' + data.productId;
    const current = data.variants.find(variant => String(variant.id) === String(data.selectedId));
    function navigate(variant, message, replace = false) {
      if (!variant || !data.variants.includes(variant)) return;
      const url = new URL(location.href);
      if (url.searchParams.get('variant') === String(variant.id)) return;
      if (message) {
        status.textContent = message;
        try { sessionStorage.setItem(storageKey, message); } catch {}
      }
      url.searchParams.set('variant', String(variant.id));
      main.setAttribute('data-mr-selection-pending', '');
      main.inert = true;
      if (replace) location.replace(url.href);
      else location.assign(url.href);
    }
    if (!current) {
      navigate(data.variants[0], 'Showing an available size and finish.', true);
      return;
    }
    const fields = document.createElement('div');
    fields.setAttribute('data-mr-selection-fields', '');
    function field(label, suffix) {
      const wrapper = document.createElement('div');
      const text = document.createElement('label');
      const select = document.createElement('select');
      select.id = 'MrAvailable-' + data.productId + '-' + suffix;
      text.htmlFor = select.id;
      text.textContent = label;
      wrapper.append(text, select);
      fields.append(wrapper);
      return select;
    }
    const size = field('Size', 'size');
    const finish = field('Finish', 'finish');
    function fill(select, values, selected) {
      const options = values.map(value => {
        const option = document.createElement('option');
        option.value = value;
        option.textContent = value;
        option.selected = value === selected;
        return option;
      });
      select.replaceChildren(...options);
    }
    const sizes = [...new Set(data.variants.map(variant => variant.options[0]))];
    fill(size, sizes, current.options[0]);
    function fillFinishes(selectedSize, selectedFinish) {
      const finishes = [...new Set(data.variants.filter(variant => variant.options[0] === selectedSize)
        .map(variant => variant.options[1]))];
      fill(finish, finishes, selectedFinish);
    }
    fillFinishes(current.options[0], current.options[1]);
    size.addEventListener('change', () => {
      const candidates = data.variants.filter(variant => variant.options[0] === size.value);
      const preferred = candidates.find(variant => variant.options[1] === finish.value);
      const target = preferred || candidates[0];
      if (!target) return;
      fillFinishes(target.options[0], target.options[1]);
      navigate(target, preferred ? '' : 'Finish changed to ' + target.options[1] + ' for this size.');
    });
    finish.addEventListener('change', () => {
      const target = data.variants.find(variant => variant.options[0] === size.value &&
        variant.options[1] === finish.value);
      navigate(target, '');
    });
    root.prepend(fields);
    try {
      const message = sessionStorage.getItem(storageKey);
      if (message) {
        status.textContent = message;
        sessionStorage.removeItem(storageKey);
      }
    } catch {}
    nativePicker.after(root);
    main.setAttribute('data-mr-available-picker-ready', data.productId);
    instances.set(main, root);
  }

  function scan() {
    for (const config of document.querySelectorAll('[data-mr-mobile-room-config]')) {
      const data = readConfig(config);
      if (!data) continue;
      const main = findMain(data.productId);
      if (main) build(data, main);
    }
  }
  function queue() {
    if (!frame) frame = requestAnimationFrame(() => { frame = 0; scan(); });
  }
  function start() {
    for (const main of document.querySelectorAll(sectionSelector)) {
      main.inert = false;
      main.removeAttribute('data-mr-selection-pending');
    }
    observer?.disconnect();
    const container = document.querySelector('main');
    if (container) {
      observer = new MutationObserver(queue);
      observer.observe(container, { childList: true, subtree: true });
    }
    scan();
  }
  document.addEventListener('submit', event => {
    if (event.target.closest('[data-mr-selection-pending], [data-mr-purchase-enquiry]')) event.preventDefault();
  }, true);
  document.addEventListener('shopify:section:load', start);
  window.addEventListener('pageshow', start);
  window.addEventListener('pagehide', () => { observer?.disconnect(); cancelAnimationFrame(frame); frame = 0; });
  window.__mrAvailablePurchasePicker = { scan };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
